var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { cloneElement, forwardRef } from 'react';
import { Tooltip as BaseTooltip } from '@base-ui/react/tooltip';
import { useFloatingPortalNode } from '@floating-ui/react';
import { PORTAL_ID } from 'modules/v2/foundation/PortalProvider';
import { PortalNodeContainer } from 'modules/v2/foundation/PortalProvider/styled';
import { ArrowSvg } from './ArrowSvg';
import { TooltipArrow, TooltipPopup } from './styled';
export { TooltipProvider } from '../TooltipProvider';
export const Tooltip = forwardRef((props, ref) => {
    const { children, title, width, delay = 500, side, disabled, 'aria-label': ariaLabel } = props, rest = __rest(props, ["children", "title", "width", "delay", "side", "disabled", 'aria-label']);
    const portalNode = useFloatingPortalNode({ id: PORTAL_ID });
    const clonedChildren = cloneElement(children, { ref });
    if (disabled || !portalNode) {
        return clonedChildren;
    }
    return (<BaseTooltip.Root>
      <BaseTooltip.Trigger render={clonedChildren} delay={delay} {...rest}/>

      <BaseTooltip.Portal container={portalNode}>
        <PortalNodeContainer>
          <BaseTooltip.Positioner sideOffset={6} side={side} aria-label={ariaLabel}>
            <TooltipPopup $width={width}>
              <TooltipArrow>
                <ArrowSvg />
              </TooltipArrow>
              {title}
            </TooltipPopup>
          </BaseTooltip.Positioner>
        </PortalNodeContainer>
      </BaseTooltip.Portal>
    </BaseTooltip.Root>);
});
